import { withJsonFormsControlProps } from "@jsonforms/react";
import FileUploadField from "./FileUploadField";

const FileUploadComponent = (props) => {
  const { handleChange, label, data, path, errors, schema, uischema, required } =
    props;
  return (
    <FileUploadField
      value={data}
      label={label}
      updateValue={(newVal) => handleChange(path, newVal)}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
    />
  );
};

export const FileUploadControl = withJsonFormsControlProps(FileUploadComponent);
